import { useTranslation } from 'react-i18next'

import { CustomSelect } from '../../../CustomSelect'
import { FormFieldsContainer, FormFieldSelect } from '../../../Form'
import { FormikEntityActionConfigFields, FormikField } from '../../../Formik'
import { TypeListItem } from '../../../ListItem'
import { TaskTypeField } from '../../TaskTypeField'
import { TASK_EDIT_TYPE_FIELDS_FIELD_NAME } from '../TaskEditTypeModal.constants'

import { getTaskEditTypeModalItems } from './FormFields.api'
import {
  getEditTypeModalLabel,
  getEditTypeModalMetaData,
  getEditTypeModalSelectApiData,
  getEditTypeModalValue,
} from './FormFields.utils'

function FormFields({ actionTypes, typeSelectProps, ...restProps }) {
  const { t } = useTranslation()

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{ ...typeSelectProps, options: actionTypes }}
      >
        <FormikField
          {...restProps}
          canClear
          required
          showLabel
          Component={FormFieldSelect}
          ListItem={TypeListItem}
          Select={CustomSelect}
          ValueItem={TaskTypeField}
          api={getTaskEditTypeModalItems}
          borderless={false}
          emptyValue={null}
          getApiData={getEditTypeModalSelectApiData}
          getApiMeta={getEditTypeModalMetaData}
          getLabel={getEditTypeModalLabel}
          getValue={getEditTypeModalValue}
          initSearchValue={null}
          inputLabel={t('Task.EditTypeFieldLabelKey')}
          name={TASK_EDIT_TYPE_FIELDS_FIELD_NAME}
          placeholder={t('Task.EditTypeFieldPlaceholderKey')}
          searchKey='search'
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default FormFields
